// extracted by mini-css-extract-plugin
var _1 = "Bookmark__Bookmark___LYC5_";
var _2 = "Bookmark__clickable___OAUcZ";
var _3 = "Bookmark__wiggle___t0t7z";
export { _1 as "Bookmark", _2 as "clickable", _3 as "wiggle" }
